// extracted by mini-css-extract-plugin
module.exports = {"page":"riverpro-firmware-update_page__YhNDK"};